import { render, staticRenderFns } from "./ManageDataBuildAccountAllocation.vue?vue&type=template&id=cd5b7da6&scoped=true"
import script from "./ManageDataBuildAccountAllocation.vue?vue&type=script&lang=js"
export * from "./ManageDataBuildAccountAllocation.vue?vue&type=script&lang=js"
import style0 from "./ManageDataBuildAccountAllocation.vue?vue&type=style&index=0&id=cd5b7da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd5b7da6",
  null
  
)

export default component.exports